PageVue
  .fp-vertical-spacing
    .fp-vertical-spacing--line
      .fp-horizontal-spacing.-s-sm.-items-center
        .fp-horizontal-spacing--column
          button.fp-icon.fp-glyph-chevron-left.-s16.-pointer(data-test='create-post.back' @click='onGoBack')
        .fp-horizontal-spacing--column
          h2.fp-title {{ t('postForm.createTitle') }}
    .fp-vertical-spacing--line(v-if='!postForm.isLoading()')
      PostFormVue#create-post-form(:club-slug='clubSlug' :form-value='postForm.value()' @confirm='createPost')
  template(v-slot:footer)
    .fp-horizontal-spacing
      .fp-horizontal-spacing--column
        FairplayerButtonVue(:text='t(\'goBack\')' icon='chevron-left' secondary data-test='create-post.footer.back' @click='onGoBack')
      .fp-horizontal-spacing--column
        FairplayerButtonVue(:text='t(\'postForm.createPost\')' :loading='creating' type='submit' form='create-post-form' icon='plus' data-test='create-post.submit')
